import MainProfileBanner from 'components/ProfileBanner/MainProfileBanner/MainProfileBanner';

export default MainProfileBanner;
